import React from "react";
import { Grid } from "@mui/material";
import resiproColor from "../../assets/Images/resiproColor.svg";

import CopyrightIcon from "@mui/icons-material/Copyright";
import { Link, useNavigate } from "react-router-dom";

function HomeFooter() {
  const navigate = useNavigate();

  return (
    <div className="footerMainOuter">
      <div className="sectionMain" style={{ paddingBottom: 0 }}>
        <div className="container">
          <div className="footerMain">
            <Grid container spacing={4}>
              <Grid item xs={12} md={5}>
                <div className="footerLogo">
                  {/* <a>
                    <img onClick={() => navigate("/")} src={resiproColor} alt="altimg"/>
                  </a> */}
                   <Link to="/">
                    <img onClick={() => navigate("/")} src={resiproColor} alt="altimg"/>
                  </Link>
                </div>
              </Grid>
              <Grid item xs={12} md={3}>
                <div className="footerMenu">
                  <h5>Interfaces</h5>
                  <p onClick={() => navigate("/AdminFeatures")}>
                    Admin Application
                  </p>
                  <p onClick={() => navigate("/ResidentFeatures")}>
                    Resident Application
                  </p>
                  <p onClick={() => navigate("/GuardFeatures")}>
                    Security Application
                  </p>
                </div>
              </Grid>
              <Grid item xs={12} md={2}>
                <div className="footerMenu">
                  <h5>Other</h5>
                  <p onClick={() => navigate("/PrivacyPolicy")}>
                    Privacy Policy
                  </p>
                  <p onClick={() => navigate("/ResiproPrivacyPolicy")}>
                    Resipro Privacy Policy
                  </p>
                </div>
              </Grid>
            </Grid>
          </div>
          <div className="copyrightSection">
            <p>
              {" "}
              <CopyrightIcon style={{ height: 16, width: 16 }} /> Copyright
              Alptech Software Solutions LLP. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomeFooter;
